import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  SimpleGrid,
  VStack,
  HStack,
  Tag,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Divider,
  Icon,
  Flex,
  Badge,
  useColorModeValue,
  AspectRatio,
  useBreakpointValue,
  Spinner,
  Center,
  // IconButton,
  Avatar,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useParams, useNavigate } from "react-router-dom";
// import { projects } from "./Project";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaBuilding,
  FaStar,
  FaTools,
  FaClock,
  FaCheckCircle,
  FaQuoteLeft,
  // FaChevronDown,
} from "react-icons/fa";
import Footer from "../footer/Footer";
// import { FiArrowRight } from "react-icons/fi";
import { MdVisibility } from "react-icons/md";
import * as Constants from "../../../constants/Constants";
import axios from "axios";

const MotionBox = motion(Box);

const ProjectDetails = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);
      useEffect(() => {
        axios
          .get(Constants.REACT_APP_API_URL + "api/upload/project")
          .then((res) => {
            if (res.data.success) {
              setImages(res.data.data);
            }
          })
          .catch((err) => console.log(err));
      }, []);
  const projects = [
  {
    id: 1,
    src: images[0]?.image_url,
    alt: "Luxury Glass Partition",
    title: "Corporate Office",
    shortDescription:
      "Modern glass partitions for a corporate office space in Mumbai designed to enhance natural light while maintaining privacy.",
    status: "Completed",
    category: "Commercial",
    location: "Mumbai",
    year: "2024",
    features: ["Frosted glass", "Soundproofing", "Custom framing"],
    relatedImages: [images[0]?.image_url, images[3]?.image_url, images[2]?.image_url],
  },
  {
    id: 2,
    src: images[1]?.image_url,
    alt: "Residential Bungalow",
    title: "Residential Bungalow",
    shortDescription:
      "Stylish residential bungalow featuring luxury glass facades and custom doors for modern living.",
    status: "Completed",
    category: "Commercial",
    location: "Bangalore",
    year: "2024",
    features: ["Double glazing", "UV protection", "Smart glass"],
    relatedImages: [images[6]?.image_url, images[0]?.image_url, images[4]?.image_url],
  },
  {
    id: 3,
    src: images[2]?.image_url,
    alt: "Residential Interior",
    title: "Luxury Apartment",
    shortDescription:
      "High-end residential interior with premium glass installations and custom finishes.",
    status: "Completed",
    category: "Residential",
    location: "Delhi",
    year: "2023",
    features: ["Tempered glass", "Decorative etching", "Integrated lighting"],
    relatedImages: [images[5]?.image_url, images[6]?.image_url, images[7]?.image_url],
  },
];
  const projectDetails = projects.find((p) => p.id === parseInt(id));
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] =
    useHomeHook(props);
  const mutedTextColor = useColorModeValue("#000000", "#000000");
  const [isLoading, setIsLoading] = useState(true);
  // const [zoomLevel, setZoomLevel] = useState(1);
  const borderColor = useColorModeValue("#000000", "#000000");

  const bgColor = useColorModeValue("#FFFFFF", "#FFFFFF");
  const cardBg = useColorModeValue("white", "#000000");
  const textColor = useColorModeValue("#000000", "#000000");
  const accentColor = useColorModeValue("black");

  const quoteRef = useRef(null);
  const isMobile = useBreakpointValue({ base: true, md: false });

  // const scrollToQuote = () => {
  //   quoteRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  // };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const testimonials = [
    {
      quote:
        "The glass installation completely transformed our space. The team was professional and the quality exceeded our expectations.",
      author: "Amityadav",
      role: "Manager",
      avatar: "https://randomuser.me/api/portraits/men/15.jpg",
    },
    {
      quote:
        "From design consultation to final installation, every step was handled with expertise and attention to detail.",
      author: "Yash Soni",
      role: "Architect",
      avatar: "https://randomuser.me/api/portraits/men/19.jpg",
    },
  ];

  if (!projectDetails) {
    return (
      <Container centerContent py={20}>
        <Heading>Project not found</Heading>
        <Button onClick={() => navigate("/project")} mt={4}>
          Back to Projects
        </Button>
      </Container>
    );
  }

  const handleImageClick = (image) => {
    setSelectedImage(image);
    onOpen();
  };

  const productTypes = [
    "Sliding Doors",
    "French Doors",
    "Glass Partitions",
    "Shower Enclosures",
  ];
  const materials = [
    "Tempered Glass",
    "Laminated Glass",
    "Aluminum Frames",
    "Wooden Frames",
  ];

  const installationTimeline = [
    { phase: "Consultation", date: "Week 1", icon: FaBuilding },
    { phase: "Measurement", date: "Week 2", icon: FaTools },
    { phase: "Manufacturing", date: "Weeks 3-4", icon: FaClock },
    { phase: "Installation", date: "Week 5", icon: FaStar },
  ];

  const features = [
    "Energy efficient glass solutions",
    "Customizable designs",
    "Noise reduction technology",
    "UV protection",
    "Easy maintenance",
    "10-year warranty",
  ];

  return (
    <Box bg={bgColor}>
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />

      <Container
        maxW="container.xl"
        px={{ base: 4, md: 8 }}
        py={{ base: 12, md: 16 }}
      >
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Hero Section */}
          <Box
            // position="relative"
            // borderRadius="xl"
            // overflow="hidden"
            // boxShadow="xl"
            mb={8}
            mt={12}
            // _hover={{
            //   "& img": {
            //     transform: "scale(1.03)",
            //   },
            // }}
          >
            <Flex
              direction={{ base: "column", md: "row" }}
              gap={8}
              align="center"
              mb={{ md: 12 }}
            >
              <Box flex={1} mb={{ base: 2 }}>
                <Badge
                  // colorScheme="blue"
                  px={4}
                  py={1}
                  borderRadius="full"
                  fontSize="sm"
                  mb={4}
                >
                  PREMIUM PROJECT
                </Badge>
                <Heading
                  size="2xl"
                  mb={4}
                  color="#000000"
                  // bgGradient="linear(to-r, #87CEEB, #800080)"
                  // bgClip="text"
                >
                  {projectDetails?.title}
                </Heading>
                <Text fontSize="lg" color={textColor} mb={6}>
                  {projectDetails?.shortDescription}
                </Text>
                <Button
                  // colorScheme="blue"
                  bg="white" 
                        color="black" 
                        boxShadow="md" 
                        _hover={{
                        boxShadow: "md",
                        bg:"white" 
                      }}
                  size="lg"
                  // rightIcon={<FiArrowRight />}
                  onClick={() => navigate("/contact")}
                >
                  Get a Quote
                </Button>
              </Box>

              <Box flex={1} position="relative">
                {isMobile ? (
                  <Image
                    src={projectDetails.src}
                    alt={projectDetails?.alt}
                    objectFit="cover"
                    borderRadius="xl"
                    boxShadow="xl"
                    onLoad={() => setIsLoading(false)}
                  />
                ) : (
                  <Box>
                    <AspectRatio ratio={4 / 3} w="100%">
                      <Image
                        src={projectDetails?.src}
                        alt={projectDetails?.alt}
                        objectFit="cover"
                        borderRadius="xl"
                        boxShadow="xl"
                        onLoad={() => setIsLoading(false)}
                      />
                    </AspectRatio>
                    {/* <IconButton
                  aria-label="Zoom image"
                  icon={<FiZoomIn />}
                  position="absolute"
                  bottom={zoomLevel === 1 ? 4 : "-2rem"}
                  right={zoomLevel === 1 ? 4 : "-4rem"}
                  colorScheme="blackAlpha"
                  borderRadius="full"
                  onClick={() => setZoomLevel((prev) => (prev === 1 ? 1.3 : 1))}
                /> */}
                  </Box>
                )}
                {isLoading && (
                  <Center
                    position="absolute"
                    top={0}
                    left={0}
                    w="100%"
                    h="100%"
                    bg="blackAlpha.100"
                    borderRadius="xl"
                  >
                    <Spinner size="xl" color="#87CEEB" />
                  </Center>
                )}
              </Box>
            </Flex>
            {/* <AspectRatio ratio={{ base: 4 / 3, md: 4 / 3 }}>
              <Image
                src={projectDetails.src}
                alt={projectDetails.alt}
                objectFit="object" 
              />
            </AspectRatio> */}

            {/* <Box
              position="absolute"
              bottom={0}
              left={0}
              right={0}
              bgGradient="linear(to-t, blackAlpha.700, transparent)"
              p={8}
              borderBottomRadius="xl"
            >
              <Flex justify="space-between" align="flex-end">
                <Box>
                  <Badge
                    colorScheme={
                      projectDetails.status === "Completed"
                        ? "green"
                        : projectDetails.status === "In Progress"
                        ? "#F6E05E"
                        : "#800080"
                    }
                    fontSize="md"
                    px={3}
                    py={1}
                    borderRadius="full"
                  >
                    {projectDetails.status}
                  </Badge>
                  <Heading
                    size="2xl"
                    color="white"
                    mt={2}
                    textShadow="0 2px 4px rgba(0,0,0,0.3)"
                  >
                    {projectDetails.title}
                  </Heading>
                </Box>
                <Button
                  colorScheme="blue"
                  size="md"
                  variant="solid"
                  // onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}
                  onClick={scrollToQuote}
                >
                  Get a Quote
                </Button>
              </Flex>
            </Box> */}
          </Box>

          {/* Project Details Grid */}
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={12}>
            <Box
              bg={cardBg}
              p={6}
              borderRadius="xl"
              boxShadow="md"
              borderLeft="4px solid"
              borderColor={"white"}
            >
              <HStack spacing={3} mb={3}>
                <Icon as={FaMapMarkerAlt} color={accentColor} boxSize={5} />
                <Heading size="md">Location</Heading>
              </HStack>
              <Text color={textColor} fontSize="lg">
                {projectDetails.location}
              </Text>
            </Box>

            <Box
              bg={cardBg}
              p={6}
              borderRadius="xl"
              boxShadow="md"
              borderLeft="4px solid"
              borderColor={"white"}
            >
              <HStack spacing={3} mb={3}>
                <Icon as={FaBuilding} color={accentColor} boxSize={5} />
                <Heading size="md">Category</Heading>
              </HStack>
              <Text color={textColor} fontSize="lg">
                {projectDetails.category}
              </Text>
            </Box>

            <Box
              bg={cardBg}
              p={6}
              borderRadius="xl"
              boxShadow="md"
              borderLeft="4px solid"
              borderColor={"white"}
            >
              <HStack spacing={3} mb={3}>
                <Icon as={FaCalendarAlt} color={accentColor} boxSize={5} />
                <Heading size="md">Year Completed</Heading>
              </HStack>
              <Text color={textColor} fontSize="lg">
                {projectDetails.year}
              </Text>
            </Box>
          </SimpleGrid>

          {/* Project Description */}
          <Box mb={12}>
            <Heading size="xl" mb={6} color={accentColor} position="relative">
              Project Overview
              <Box
                as="span"
                position="absolute"
                bottom="-8px"
                left={0}
                w="80px"
                h="4px"
                // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                borderRadius="full"
              />
            </Heading>
            <Text fontSize="lg" lineHeight="tall" color={textColor} mb={6}>
              {projectDetails.shortDescription}
            </Text>
            <Text fontSize="lg" lineHeight="tall" color={textColor}>
              This innovative glass installation transformed the space with
              modern design elements that maximize natural light while
              maintaining privacy. Our team worked closely with the client to
              deliver a solution that combines aesthetic appeal with functional
              performance.
            </Text>
          </Box>

          <Divider my={12} borderColor="#000000" />

          {/* Project Gallery */}
          <Box mb={12}>
            <Heading size="xl" mb={8} color={accentColor} position="relative">
              Project Gallery
              <Box
                as="span"
                position="absolute"
                bottom="-8px"
                left={0}
                w="80px"
                h="4px"
                // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                borderRadius="full"
              />
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
              {projectDetails.relatedImages.map((img, index) => (
                <MotionBox
                  key={index}
                  whileHover={{ scale: 1.03 }}
                  transition={{ duration: 0.2 }}
                  cursor="pointer"
                  onClick={() => handleImageClick(img)}
                >
                  <Box
                    borderRadius="xl"
                    overflow="hidden"
                    boxShadow="md"
                    position="relative"
                    _hover={{
                      boxShadow: "xl",
                      "& .overlay": {
                        opacity: 1,
                      },
                    }}
                  >
                    <Image
                      src={img}
                      alt={`Gallery ${index + 1}`}
                      objectFit="cover"
                      h="300px"
                      w="100%"
                    />
                    <Box
                      className="overlay"
                      position="absolute"
                      top={0}
                      left={0}
                      right={0}
                      bottom={0}
                      bg="blackAlpha.500"
                      opacity={0}
                      transition="opacity 0.3s"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <VStack spacing={2}>
                        <Icon as={MdVisibility} color="white" w={6} h={6} />
                        <Text color="white" fontSize="sm" fontWeight="bold">
                          Tap to Open
                        </Text>
                      </VStack>
                    </Box>
                  </Box>
                </MotionBox>
              ))}
            </SimpleGrid>
          </Box>

          <Divider my={12} borderColor="#000000" />

          {/* Product Features */}
          <Box mb={12}>
            <Heading size="xl" mb={8} color={accentColor} position="relative">
              Product Features
              <Box
                as="span"
                position="absolute"
                bottom="-8px"
                left={0}
                w="80px"
                h="4px"
                // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                borderRadius="full"
              />
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
              {features.map((feature, index) => (
                <HStack
                  key={index}
                  align="flex-start"
                  spacing={4}
                  bg={cardBg}
                  p={6}
                  borderRadius="xl"
                  boxShadow="md"
                >
                  <Icon as={FaCheckCircle} color="black" opacity={0.3} mt={1} />
                  <Text fontSize="lg" color={textColor}>
                    {feature}
                  </Text>
                </HStack>
              ))}
            </SimpleGrid>
          </Box>

          {/* Product Types */}
          <Box mb={12}>
            <Heading size="xl" mb={8} color={accentColor} position="relative">
              Product Types
              <Box
                as="span"
                position="absolute"
                bottom="-8px"
                left={0}
                w="80px"
                h="4px"
                // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                borderRadius="full"
              />
            </Heading>
            <Flex wrap="wrap" gap={4}>
              {productTypes.map((product, index) => (
                <Tag
                  key={index}
                  size="lg"
                  variant="subtle"
                  // colorScheme="blue"
                  borderRadius="full"
                  px={6}
                  py={2}
                  boxShadow="sm"
                >
                  {product}
                </Tag>
              ))}
            </Flex>
          </Box>

          {/* Materials Used */}
          <Box mb={12}>
            <Heading size="xl" mb={8} color={accentColor} position="relative">
              Materials Used
              <Box
                as="span"
                position="absolute"
                bottom="-8px"
                left={0}
                w="80px"
                h="4px"
                // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                borderRadius="full"
              />
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
              {materials.map((material, index) => (
                <Box
                  key={index}
                  bg={cardBg}
                  p={6}
                  borderRadius="xl"
                  boxShadow="md"
                >
                  <HStack spacing={4}>
                    <Box
                      w={3}
                      h={3}
                      bg="black"
                      borderRadius="full"
                      flexShrink={0}
                    />
                    <Text fontSize="lg" color={textColor}>
                      {material}
                    </Text>
                  </HStack>
                </Box>
              ))}
            </SimpleGrid>
          </Box>

          {/* Installation Timeline */}
          {/* <Box mb={12}>
            <Heading size="xl" mb={8} color={accentColor}>
              Installation Timeline
            </Heading>
            <VStack spacing={6} align="stretch">
              {installationTimeline.map((event, index) => (
                <HStack
                  key={index}
                  spacing={6}
                  bg={cardBg}
                  p={6}
                  borderRadius="xl"
                  boxShadow="md"
                >
                  <Box
                    w={12}
                    h={12}
                    bg="#87CEEB"
                    borderRadius="full"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                  >
                    <Icon as={event.icon} color={accentColor} boxSize={5} />
                  </Box>
                  <Box flex="1">
                    <Heading size="md" mb={2}>
                      {event.phase}
                    </Heading>
                    <Text color="#000000">{event.date}</Text>
                  </Box>
                </HStack>
              ))}
            </VStack>
          </Box> */}
          <Box mb={16}>
            <VStack align="start" spacing={8} w="100%">
              <Heading size="xl" color={accentColor} position="relative">
                Installation Timeline
                <Box
                  as="span"
                  position="absolute"
                  bottom="-8px"
                  left={0}
                  w="80px"
                  h="4px"
                  // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                  borderRadius="full"
                />
              </Heading>
              <VStack
                spacing={4}
                align="stretch"
                w="100%"
                position="relative"
                _before={{
                  content: '""',
                  position: "absolute",
                  left: "30px", // Align with icon center
                  top: "24px", // Start below first icon
                  bottom: "24px", // End above last icon
                  w: "2px",
                  // bg: useColorModeValue("#87CEEB", "#87CEEB"),
                  borderRadius: "full",
                  zIndex: 0,
                }}
              >
                {installationTimeline.map((event, index) => (
                  <MotionBox
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                    position="relative"
                    zIndex={1}
                  >
                    <HStack
                      spacing={6}
                      bg={cardBg}
                      p={6}
                      borderRadius="xl"
                      boxShadow="md"
                      borderLeft="4px solid"
                      borderColor={"white"}
                      _hover={{
                        transform: "translateX(4px)",
                        boxShadow: "lg",
                      }}
                      transition="all 0.3s ease"
                    >
                      <Box
                        w={12}
                        h={12}
                        bg={`${accentColor}.50`}
                        borderRadius="full"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexShrink={0}
                        boxShadow="sm"
                      >
                        <Icon as={event.icon} color={accentColor} boxSize={5} />
                      </Box>
                      <Box flex="1">
                        <Heading size="md" mb={1} fontWeight="semibold">
                          {event.phase}
                        </Heading>
                        <HStack spacing={2}>
                          <Icon
                            as={FaCalendarAlt}
                            color={mutedTextColor}
                            boxSize={4}
                          />
                          <Text
                            color={mutedTextColor}
                            fontSize="sm"
                            fontWeight="medium"
                          >
                            {event.date}
                          </Text>
                        </HStack>
                        {index < installationTimeline.length - 1 && (
                          <Box
                            position="absolute"
                            bottom="-18px"
                            left="30px"
                            w="24px"
                            h="24px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            {/* <Icon 
                    as={FaChevronDown} 
                    color={mutedTextColor} 
                    boxSize={4} 
                  /> */}
                          </Box>
                        )}
                      </Box>
                    </HStack>
                  </MotionBox>
                ))}
              </VStack>
            </VStack>
          </Box>
          {/* Testimonials */}
          {/* <Box mb={12}>
            <Heading size="xl" mb={8} color={accentColor}>
              Client Testimonials
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
              <Box
                bg={cardBg}
                p={8}
                borderRadius="xl"
                boxShadow="md"
                position="relative"
                _before={{
                  content: '""',
                  position: "absolute",
                  top: 6,
                  left: 6,
                  w: 10,
                  h: 8,
                  bg: "#87CEEB",
                  borderRadius: "xl",
                  zIndex: 0,
                }}
              >
                <Box position="relative" zIndex={1}>
                  <Icon as={FaStar} color="#F6E05E" boxSize={5} mb={4} />
                  <Text
                    fontSize="lg"
                    color={textColor}
                    fontStyle="italic"
                    mb={4}
                  >
                    "The glass installation completely transformed our space.
                    The team was professional and the quality exceeded our
                    expectations."
                  </Text>
                  <Text fontWeight="bold" color={accentColor}>
                    — Sarah Johnson
                  </Text>
                </Box>
              </Box>
              <Box
                bg={cardBg}
                p={8}
                borderRadius="xl"
                boxShadow="md"
                position="relative"
                _before={{
                  content: '""',
                  position: "absolute",
                  top: 6,
                  left: 6,
                  w: 10,
                  h: 8,
                  bg: "#87CEEB",
                  borderRadius: "xl",
                  zIndex: 0,
                }}
              >
                <Box position="relative" zIndex={1}>
                  <Icon as={FaStar} color="#F6E05E" boxSize={5} mb={4} />
                  <Text
                    fontSize="lg"
                    color={textColor}
                    fontStyle="italic"
                    mb={4}
                  >
                    "From design consultation to final installation, every step
                    was handled with expertise and attention to detail."
                  </Text>
                  <Text fontWeight="bold" color={accentColor}>
                    — Michael Chen
                  </Text>
                </Box>
              </Box>
            </SimpleGrid>
          </Box> */}

          <Box mb={12}>
            <VStack align="start" spacing={8}>
              <Heading size="xl" color={accentColor} position="relative">
                Client Testimonials
                <Box
                  as="span"
                  position="absolute"
                  bottom="-8px"
                  left={0}
                  w="80px"
                  h="4px"
                  // bgGradient={`linear(to-r, ${accentColor}, #800080)`}
                  borderRadius="full"
                />
              </Heading>
              <SimpleGrid
                columns={{ base: 1, md: 2 }}
                spacing={{ base: 4, md: 6 }}
              >
                {testimonials.map((testimonial, index) => (
                  <Box
                    key={index}
                    bg={cardBg}
                    p={8}
                    borderRadius="xl"
                    boxShadow="md"
                    border="1px solid"
                    borderColor={borderColor}
                    position="relative"
                  >
                    <Box position="relative">
                      <Icon
                        as={FaQuoteLeft}
                        color={mutedTextColor}
                        boxSize={6}
                        mb={4}
                      />
                      <Text
                        fontSize="lg"
                        color={textColor}
                        fontStyle="italic"
                        mb={6}
                      >
                        {testimonial.quote}
                      </Text>
                      <HStack spacing={4}>
                        <Avatar
                          name={testimonial.author}
                          src={testimonial.avatar}
                          size="md"
                        />
                        <Box>
                          <Text fontWeight="bold" color={accentColor}>
                            {testimonial.author}
                          </Text>
                          <Text fontSize="sm" color={mutedTextColor}>
                            {testimonial.role}
                          </Text>
                        </Box>
                      </HStack>
                    </Box>
                  </Box>
                ))}
              </SimpleGrid>
            </VStack>
          </Box>
          {/* CTA Section */}
          <Box
            ref={quoteRef}
            // bgGradient="linear(to-r, #87CEEB, #800080)"
            p={12}
            borderRadius="xl"
            textAlign="center"
            // boxShadow="xl"
          >
            <Heading size="xl" color="black" mb={6}>
              Ready to Start Your Project?
            </Heading>
            <Text fontSize="xl" color="black.100" mb={8}>
              Contact us today for a free consultation and quote
            </Text>
            <Button
             bg="black" 
                  opacity={0.7}
                  color={"white"}
              size="lg"
              _hover={{ bg: "white", color: "black" }}
              onClick={() => navigate("/contact")}
            >
              Get in Touch
            </Button>
          </Box>

          {/* Image Modal */}
          <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
            <ModalOverlay bg="blackAlpha.800" />
            <ModalContent bg="transparent" boxShadow="none" mx={{ base: 4, md: 0 }}>
              <ModalCloseButton
                color="white"
                size={{base:"sm",md:"lg"}}
                bg="blackAlpha.600"
                _hover={{ bg: "blackAlpha.700" }}
                top={{ base:"1rem", md: "1.5rem" }}
                right={{ base: "1rem", md: "1.5rem" }}
              />
              <ModalBody p={0}>
                <Image
                  src={selectedImage}
                  alt="Selected project image"
                  w="100%"
                  h="auto"
                  objectFit="contain"
                  borderRadius="xl"
                />
              </ModalBody>
            </ModalContent>
          </Modal>
        </MotionBox>
      </Container>
      <Footer />
    </Box>
  );
};

export default ProjectDetails;
